import React from "react";
import {
	Button,
	ChildrenProps,
	ClassNameProps,
	Column,
	If,
	Image,
	makeClassName,
	Row,
	StyleProps,
	useRequiredContext,
} from "@hex-insights/core";
import {
	ModelComponents,
	StaticURLs,
	useElementSize,
	useViewerCommunicationRecordCountsQuery,
} from "@s-i-s-i/see-learning.shared";
import styles from "./styles.module.css";

export type WelcomeBannerPermissionRequiredProps = Partial<ChildrenProps>;

export function WelcomeBannerPermissionRequired({ children }: WelcomeBannerPermissionRequiredProps) {
	return (
		<ModelComponents.OmniCreateButtonPermissionRequired>{children}</ModelComponents.OmniCreateButtonPermissionRequired>
	);
}

export type WelcomeBannerProps = Partial<ClassNameProps & StyleProps>;

export function WelcomeBanner({ className, style }: WelcomeBannerProps) {
	const { openModal } = useRequiredContext(ModelComponents.OmniCreateModalContext);

	const { loading, data } = useViewerCommunicationRecordCountsQuery();
	const hasPublished =
		data &&
		(data.announcementConnection?.totalCount ?? 0) +
			(data.calendarEventConnection?.totalCount ?? 0) +
			(data.newsletterConnection?.totalCount ?? 0) +
			(data.postConnection?.totalCount ?? 0) >
			0;

	const shouldNotRender = loading || !data || hasPublished;

	const containerRef = React.useRef<HTMLDivElement | null>(null);
	const { width } = useElementSize(containerRef, shouldNotRender);
	const isNarrow = width < 600;

	if (shouldNotRender) {
		return null;
	}

	return (
		<div ref={containerRef} onClick={openModal}>
			<Row
				justify="space-between"
				align="center"
				className={makeClassName(styles["welcome-banner"], isNarrow ? styles["welcome-banner--narrow"] : "", className)}
				style={{ rowGap: "1rem", ...style }}
			>
				<Column justify="spaced-start" verticalSpacing="1rem" style={{ flexGrow: 1 }}>
					<Column justify="spaced-start" verticalSpacing="0.5rem">
						<span className={styles["welcome-banner__heading"]}>Welcome to the SEE&nbsp;Learning Community Portal</span>

						<span>Join the community by sharing and engaging with others.</span>
					</Column>

					<Button variant="primary" onClick={openModal}>
						Create Your First Post
					</Button>
				</Column>

				<If condition={!isNarrow}>
					<Image src={StaticURLs.Images.creativePerson1} sizing="height-scaled" style={{ height: "8rem" }} />
				</If>
			</Row>
		</div>
	);
}
